var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreakfast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 49 42",
    style: {
      enableBackground: "new 0 0 49 42"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;sticker-rule:evenodd;fill:#CADDD9;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_87_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_88_",
    className: "st0",
    d: "M35.1,11.3c0.3,0,0.5-0.1,0.7-0.3l3.3-3.8c0.4-0.4,0.3-1-0.1-1.4c-0.4-0.4-1-0.3-1.4,0.1 l-3.3,3.8c-0.4,0.4-0.3,1,0.1,1.4C34.6,11.2,34.8,11.3,35.1,11.3z M13.4,10.1c0.2,0.3,0.5,0.5,0.9,0.5c0.2,0,0.3,0,0.5-0.1 c0.5-0.3,0.6-0.9,0.3-1.4l-2.3-3.8c-0.3-0.5-0.9-0.6-1.4-0.3c-0.5,0.3-0.6,0.9-0.3,1.4L13.4,10.1z M40.9,21.3c0,0,0.1,0,0.1,0 l5.2-0.6c0.5-0.1,0.9-0.6,0.9-1.1c-0.1-0.5-0.6-0.9-1.1-0.9l-5.2,0.6c-0.5,0.1-0.9,0.6-0.9,1.1C40,20.9,40.4,21.3,40.9,21.3z  M3.1,20.4L7.6,21c0,0,0.1,0,0.1,0c0.5,0,0.9-0.4,1-0.9c0.1-0.5-0.3-1-0.9-1.1l-4.4-0.6c-0.5-0.1-1,0.3-1.1,0.9 C2.2,19.8,2.6,20.3,3.1,20.4z M21.9,16.2c-0.5,0.2-0.7,0.8-0.5,1.3c0.2,0.5,0.8,0.7,1.3,0.5c2.3-1,4.9-0.6,6.8,1 c0.2,0.2,0.4,0.2,0.7,0.2c0.3,0,0.5-0.1,0.7-0.3c0.4-0.4,0.3-1-0.1-1.4C28.4,15.4,24.9,14.9,21.9,16.2z M47.5,26h-8.3 c0,0,0-0.1,0-0.1c0.3-4.5-1.5-8.9-4.9-11.9c-6-5.3-15.2-4.7-20.5,1.3c-2.6,3-3.9,6.8-3.6,10.7H1.5C0.7,26,0,26.7,0,27.5 C0,28.3,0.7,29,1.5,29h46c0.8,0,1.5-0.7,1.5-1.5C49,26.7,48.3,26,47.5,26z M36.2,26H13.2c-0.3-3.2,0.7-6.3,2.8-8.7 c4.2-4.8,11.5-5.2,16.3-1c2.7,2.4,4.1,5.8,3.9,9.4C36.2,25.8,36.2,25.9,36.2,26z M24.7,7.5c0.5,0,1-0.4,1-1V1c0-0.5-0.4-1-1-1 c-0.5,0-1,0.4-1,1v5.6C23.7,7.1,24.1,7.5,24.7,7.5z M25.1,33.5c-0.6-0.6-1.5-0.6-2.1,0l-5.5,5.9c-0.6,0.6-0.6,1.6,0,2.2 c0.6,0.6,1.5,0.6,2.1,0l4.5-4.8l4.5,4.8c0.6,0.6,1.5,0.6,2.1,0c0.6-0.6,0.6-1.6,0-2.2L25.1,33.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreakfast);
export default __webpack_public_path__ + "static/media/breakfast.d891fa018a23aca50dae0428a38d41f7.svg";
export { ForwardRef as ReactComponent };